<template>
    <div class="third-step-container">
        <div class="title">{{ $t('message.passwordRecovery.thirdStep.title') }}</div>
        <div class="break-line"></div>
        <div class="step-block">
            <div class="input-block">
                <BasePasswordInput
                    :label="$t('message.passwordRecovery.thirdStep.password.label')"
                    :name="'password'"
                    :validate-rules="'password'"
                    v-model="password"
                />
            </div>
        </div>
        <div class="step-block">
            <div class="input-block">
                <BasePasswordInput
                    :label="$t('message.passwordRecovery.thirdStep.repeatPassword.label')"
                    :name="'passwordConfirmation'"
                    :validate-rules="`passwordConfirmation:${this.password}`"
                    v-model="confirmPassword"
                />
            </div>
        </div>
        <div class="btns-block">
            <div class="btn-container">
                <BaseButton
                    :text="$t('message.passwordRecovery.thirdStep.saveBtn')"
                    :disabled="isSaveBtnDisabled"
                    @click="setPassword()"
                />
            </div>

            <div class="btn-container">
                <BaseButton
                    :text="$t('message.passwordRecovery.thirdStep.cancelBtn')"
                    class="cancel-btn"
                    @click="$router.push({ name: 'SignIn' })"
                />
            </div>
        </div>
    </div>
</template>

<script>
import BasePasswordInput from '../../components/base/BasePasswordInput.vue';
import BaseButton from '../../components/base/BaseButton.vue';

export default {
    name: 'ThirdStep',
    components: {
        BasePasswordInput,
        BaseButton
    },
    data() {
        return {
            password: '',
            confirmPassword: ''
        }
    }, 
    methods: {
        setPassword() {
            this.$emit('setPassword', this.password);
        }
    }, 
    computed: {
        isSaveBtnDisabled() {
            return this.isHasFildsErrors || this.isHasEmptyFields;
        },
        isHasFildsErrors() {
            return this.errors.items.length > 0;
        },
        isHasEmptyFields() {
            return !this.password || !this.confirmPassword;
        },
    }
}
</script>

<style lang="scss" scoped>
.third-step-container {
    @include base-recovery-password-step-container;
    height: 539px;
}

.title {
    @include recovery-password-title;
    margin-bottom: 25px;
}

.break-line {
    @include recovery-password-break-line;
}

.step-block {
    width: 100%;
    display: flex;
    justify-content: flex-start;
}

.input-block {
    width: 418px;
}

.btns-block {
    width: 100%;
    margin-top: 60px;
    display: flex;
}

.btn-container {
    width: 150px;
    height: 54px;
}

.btn-container {
    margin-right: 20px;
}

.cancel-btn {
    border: 1px solid var(--base-cancel-btn-border-bgc);
    background-color: var(--base-cancel-btn-bgc);
    color: var(--base-cancel-btn-color);
}

@media screen and (max-width: 750px) {
    .third-step-container {
        padding: 0 5%;
    }

    .input-block {
        max-width: 100%;
    }
}
</style>